<template>
  <div
    class="main-card d-flex p-a-16 align-items-center align-self-stretch justify-content-between"
    @click="handleCardClick"
  >
    <div
      class="its-texts d-flex flex-column align-items-start"
      style="gap: 8px"
    >
      <p class="f-Overpass f-16 f-w-600 my-0">{{ nama }}</p>
      <div class="d-flex mt-1 align-items-center" style="gap: 4px">
        <img src="../../../assets/icons/time.svg" alt="time" />
        <p class="f-Overpass f-12 f-w-400 mt-1 my-0 f-c-grey">
          {{ displayDuration }}
        </p>
      </div>
    </div>

    <div class="d-flex flex-column justify-content-between align-items-center">
      <p class="f-Overpass f-16 f-w-400 my-0 f-c-blue">
        {{ displaySaldo(harga) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "cardLayanan",
  props: {
    nama: String,
    durasi: Number,
    harga: Number,
    idmesin: String,
    idLayanan: String,
    idoutlet: String,
    namaMesin: String,
    index: Number,
  },

  computed: {
    ...mapState("scan", {
      dataPesanan: "dataPesanan",
      dataLayanan: "dataLayanan",
    }),

    displayDuration() {
      const minutes = Math.floor(this.durasi / 60);
      return `${minutes} menit`;
    },
  },

  methods: {
    handleCardClick() {
      let data = {
        idmesin: this.idmesin,
        idsnap_layanan: this.idLayanan,
        total: this.harga,
        grandtotal: this.harga,
        namaMesin: this.namaMesin,
        namaLayanan: this.nama,
        durasiLayanan: this.durasi,
        idOutlet: this.idoutlet,
      };
      this.$store.commit("scan/dataIdLayananMesin", data);
      // console.log(this.dataPesanan);
      this.$router.push({ name: "pilihEpay", query: {
        idowner: this.dataLayanan.data_mesin.idowner
      }});
    },

    displaySaldo(money) {
      const formattedMoney = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(money);

      return formattedMoney.replace(/\.00$/, "");
    },
  },
};
</script>

<style scoped>
.main-card {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
}
</style>
